import React from 'react';
import { createPortal } from 'react-dom';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';
import './ImageViewer.css';

const ImageViewer = ({ 
  images = [], 
  currentIndex = 0, 
  isVisible = false, 
  onClose, 
  onNext, 
  onPrevious 
}) => {
  if (!isVisible || !images.length) return null;

  const imageViewerContent = (
    <div className="image-viewer-overlay" onClick={onClose}>
      <div className="image-viewer-content" onClick={(e) => e.stopPropagation()}>
        <img
          src={images[currentIndex]}
          alt="Message attachment"
          className="viewer-image"
        />
        
        {/* Image Counter */}
        {images.length > 1 && (
          <div className="image-counter">
            {currentIndex + 1} / {images.length}
          </div>
        )}
        
        {/* Modal Navigation Arrows */}
        {images.length > 1 && (
          <>
            <button 
              className="modal-nav-arrow modal-nav-arrow-left"
              onClick={onPrevious}
              aria-label="Previous image"
            >
              <FaChevronLeft />
            </button>
            <button 
              className="modal-nav-arrow modal-nav-arrow-right"
              onClick={onNext}
              aria-label="Next image"
            >
              <FaChevronRight />
            </button>
          </>
        )}
        
        {/* Close Button */}
        <button 
          className="modal-close-button"
          onClick={onClose}
          aria-label="Close image viewer"
        >
          <FaTimes />
        </button>
      </div>
    </div>
  );

  // Use createPortal to render the ImageViewer at the document body level
  return createPortal(imageViewerContent, document.body);
};

export default ImageViewer;
